export default {
    newSearch: {
        availableRegions: [],
        availableChains: [],
        availableFirms: [],
        availablePhotographers: [],
        availableSellers: [],
        availableProductGroups: [],
        groupedProducts: []
    },
    search: null
};
